module.exports = __webpack_public_path__ + "media/Yipi_MueveMexico.db93c762.mp4";